import { render, staticRenderFns } from "./UsersPrivilegeUsers.vue?vue&type=template&id=38174f63&scoped=true&"
import script from "./UsersPrivilegeUsers.vue?vue&type=script&lang=js&"
export * from "./UsersPrivilegeUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38174f63",
  null
  
)

export default component.exports